// extracted by mini-css-extract-plugin
export var dropdown = "_jv-0";
export var imagePlaceholder = "_jv-2";
export var imageWrapper = "_jv-3";
export var productImage = "_jv-1";
export var truncateContainer = "_jv-4";
export var truncateText = "_jv-5";